/*$(".custom-menu").hide();*/
$('.menu-show').click(function () {
  $('.custom-menu').slideToggle()
  $('body').toggleClass('menu-open')
  $(this).toggleClass('open')
  if ($(this).hasClass('open')) {
    $('body').addClass('menu-open')
  }
  $('#mini-cart-items').slideUp()
})
$('.close-menu').click(function () {
  $('.custom-menu').slideUp()
  $('.menu-show').toggleClass('open')
  $('body').removeClass('menu-open')
})
$('.custom-overlay').click(function () {
  $('body').removeClass('menu-open')
  $('.custom-menu').slideUp()
  $('.menu-show').removeClass('open')
  $('#mini-cart-items').slideUp()
})
$('.site-header__cart').click(function () {
  $('body').removeClass('menu-open')
  $('.custom-menu').slideUp()
  $('.menu-show').removeClass('open')
})

//Responsive and on load. if window width less than 768px, logo should be on the right of nav, if at least 768px; logo should be on left of nav
$(window).on('resize load', function () {
  let windowWidth = $(window).width()

  if (windowWidth < 768) {
    $('.medium-up--one-quarter.logo-align--left').insertAfter('#AccessibleNav')
  }
  if (windowWidth >= 768) {
    $('.medium-up--one-quarter.logo-align--left').insertBefore('#AccessibleNav')
  }
})

if ($(window).width() <= 640) {
  $('.mobile-footer').click(function () {
    $(this).children('.link').slideToggle()
    $(this).toggleClass('open-footer')
  })
}
$(document).ready(function () {
  $('.desktop-side-category .custom-category ul li a').hover(function () {
    $(this).toggleClass('open')
    $(this).children('span').removeClass('animated')
    $(this).children('span').toggleClass('wow fadeInLeft animated')
  })
  var maxHeight = 0
  $('.template-blog .blog-article li').each(function () {
    if ($(this).height() > maxHeight) {
      maxHeight = $(this).height()
    }
    $(this).css({ height: maxHeight.toString() + 'px' })
  })
})
if ($(window).width() <= 480) {
  $('.custom-home .custom-category').addClass('cat-close')
  $('.custom-home .custom-category').click(function () {
    if ($('.custom-home .custom-category').hasClass('cat-close')) {
      $('.custom-home .custom-category').removeClass('cat-close')
      $(this).siblings().addClass('cat-close')
      $(this).next().addClass('opn-cat')
      $(this).next().siblings().removeClass('opn-cat')
    } else {
      $('.custom-home .custom-category').addClass('cat-close')
    }
  })
}
$('.cart__qty-input').click(function () {
  $('.sp-quantity').addClass('change')
  $('.sp-plus').show()
  $('.sp-minus').show()
})

$(document).mouseup(function (e) {
  var plus = $('.sp-plus')
  var minus = $('.sp-minus')
  if (
    !$('.cart__qty-input').is(e.target) &&
    !plus.is(e.target) &&
    plus.has(e.target).length == 0 &&
    !minus.is(e.target) &&
    minus.has(e.target).length == 0
  ) {
    plus.hide()
    minus.hide()
  }
})

$('.my-account #navi li').click(function () {
  $(this).addClass('active')
  $(this).removeClass('deactive')
  $(this).siblings().removeClass('active')
  if ($('.my-account #navi li').hasClass('active')) {
    $(this).siblings().addClass('deactive')
    if ($('.my-account #navi li:first-child').hasClass('active')) {
      $(this).next().addClass('da-tab')
    } else {
      $('.my-account #navi li').next().removeClass('da-tab')
    }
  }
})
if ($(window).width() <= 480) {
  $('.product-form .selector-wrapper').insertAfter(
    '.product-form .product-form__item--quantity'
  )
}
$('.site-header__account').hover(function () {
  $('.site-header__mobile-nav').toggleClass('open')
})
$('.custom-home').parent('html').css("{ 'paddinng-bottom': '0'; }")
$('.custom-home').parent().removeClass('rte')
